import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { FormGroupDirective } from "@angular/forms";
import { FormText, FormGroup } from "@coso/forms";
import { FolderNamingRule, FolderNamingRuleName, ISettings, LibraryRule } from "../../../../models/auto-generated";
import { Constants } from "../../constants";
import { BehaviorSubject } from "rxjs";

@Component({
  standalone:false,
  templateUrl: "./folder-settings.component.html",
  styleUrls: ["./folder-settings.component.scss"]
})
export class FolderSettingsComponent implements OnInit {
  @ViewChild("folderNamingRulePopover", { static: true }) folderNamingRulePopover: TemplateRef<any>;
  FolderNamingRule = FolderNamingRule;
  LibraryRule = LibraryRule;

  formText: FormText<ISettings>;
  formGroup: FormGroup<ISettings>;
  public isReadOnly = new BehaviorSubject<boolean>(false);

  get isReadOnly$() {
    return this.isReadOnly.asObservable();
  }

  get libraryCreateRulePattern(): LibraryRule {
    return this.rootFormGroupDirective.control.get("libraryDistribution").get("pattern").value;
  }

  constructor(private rootFormGroupDirective: FormGroupDirective) {}

  ngOnInit(): void {
    this.formGroup = this.rootFormGroupDirective.control.get("settings") as FormGroup<ISettings>;    
    this.formText = {
      folderNamingRule: {
        label: "Folder Naming Rule",
        labelClass: "col-lg-3",
        inputContainerClass: "col-lg-5",
        popover: this.folderNamingRulePopover,
        options: Object.keys(FolderNamingRule)
          .filter((k) => isNaN(Number(k)))
          .map((k) => ({ label: FolderNamingRuleName.get(FolderNamingRule[k]), value: FolderNamingRule[k] }))
      },
      folderNamingPattern: {
        label: "Folder Name",
        labelClass: "col-lg-3",
        inputContainerClass: "col-lg-5",
        popover: "The name of the folder to be created. The following placeholders can be used: {0} for the name of the object and {1} for the id of the object.",
        placeholder: Constants.DefaultFolderNamePattern,
        errors: {
          required: "The Folder Name field is required."
        }
      }
    }; 
  }  
}
